import styled from 'styled-components';

import { BaseButton, BaseButtonProps } from '#/components/Button/Button';
import { ThemeConfig } from '#/service/config';
import { ButtonVariant } from '#/service/constants';
import { remify } from '#/service/utils';

export const PaymentContainer = styled.div`
  width: 100%;
  max-width: ${remify(450)};
  margin: 0 auto;
`;

export const Tabs = styled.div.attrs(() => ({
  role: 'tablist',
}))`
  display: flex;
  min-height: ${remify(48)};
  margin-bottom: ${remify(24)};
`;

interface TabProps extends Omit<BaseButtonProps, '$variant'> {
  theme: ThemeConfig;
  $selected: boolean;
}

export const Tab = styled(BaseButton).attrs(
  ({ theme: _theme, ...rest }: TabProps) => ({
    'aria-selected': rest.$selected,
    role: 'tab',
    $variant: ButtonVariant.Ghost,
    ...rest,
  })
)`
  display: inline-flex;
  flex: 1;
  justify-content: center;
  border-radius: 0;
  color: var(--buttonPrimaryBackground);

  ${({ $selected }) =>
    $selected &&
    `box-shadow: inset 0 -2px 0 0 var(--tabMenuHighlightBackground);`}
`;

export const TabPanel = styled.div.attrs(() => ({
  role: 'tabpanel',
}))<{ $selected: boolean }>`
  ${({ $selected }) => !$selected && `display: none;`}
`;

export const Icon = styled.img`
  margin-right: ${remify(8)};
  height: ${remify(24)};
`;

export const Text = styled.span`
  font: var(--fontStyleFootnote);
`;

export const DisclaimerWrapper = styled.div`
  margin: ${remify(45)} 0;
`;
